import { render, staticRenderFns } from "./shorts-message.vue?vue&type=template&id=265b2e3e&scoped=true"
import script from "./shorts-message.vue?vue&type=script&lang=js"
export * from "./shorts-message.vue?vue&type=script&lang=js"
import style0 from "./shorts-message.vue?vue&type=style&index=0&id=265b2e3e&prod&lang=scss&scoped=true"
import style1 from "./shorts-message.vue?vue&type=style&index=1&id=265b2e3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265b2e3e",
  null
  
)

export default component.exports